import React from 'react';

/**
 * Show the formatted Activation Code when available.
 * Show the formatted Requisition Number when no Activation Code is available.
 * Don't show anything if neither value is available.
 */
const ActivationNumber = ({ omsRequisition }) => {
	let displayText;

	const formattedActivationCode = formatActivationCodeForDisplay(omsRequisition?.activationCode);
	if (formattedActivationCode) {
		displayText = `Activation Number: ${formattedActivationCode}`;
	} else {
		const formattedRequisitionId = formatRequisitionNumberForDisplay(omsRequisition?.id);
		if (formattedRequisitionId) {
			displayText = `Requisition Number: ${formattedRequisitionId}`;
		}
	}

	if (displayText) {
		return <div className="small mt-5">{displayText}</div>;
	}

	return null;
};

/**
 * Insert hyphens into a raw activation code.
 * Example: C123456789 -> C123-456-789
 */
export const formatActivationCodeForDisplay = (activationCode) => {
	return activationCode?.match(/(^.{4})|(.{1,3})/g)?.join('-');
};

/**
 * Insert a pound symbol and hyphens into a requisition number.
 * Example: 12345678 -> #123-456-78
 */
export const formatRequisitionNumberForDisplay = (omsRequisitionId) => {
	if (omsRequisitionId) {
		const parts = (omsRequisitionId + '')?.match(/(.{1,3})/g);
		return parts?.length ? `#${parts.join('-')}` : null;
	}
	return null;
};

export default ActivationNumber;
